<template>
  <div class="p-3">
    <v-data-table
      :headers="headers"
      :items="connexionsList"
      :loading="isLoading"
      :search="search"
      loading-text="Chargement..."
      no-data-text="Aucune demande"
    >
      <template v-slot:top>
        <div class="d-flex mb-5">
          <div class="mr-4">
            <v-text-field
              append-icon="mdi-magnify"
              label="Rechercher par nom"
              clearable
              v-model="search"
              outlined
              hide-details
            >
            </v-text-field>
          </div>

          <div class="mr-4">
            <v-select
              :items="cities"
              hide-details
              multiple
              small-chips
              outlined
              v-model="selectedCity"
              chips
              label="Commune"
            >
            </v-select>
          </div>
        </div>
      </template>

      <template v-slot:item.external_id="{ item }">
        <div v-if="item.external_id">
          <router-link
            v-if="item.provider_id"
            :to="'/summary/' + encodeUri(item.provider_id)"
          >
            Voir la fiche
          </router-link>
          <router-link
            v-else
            :to="`https://base.apidae-tourisme.com/gerer/objet-touristique/${item.external_id}/consulter/?5`"
          >
            Voir sur apidae
          </router-link>
        </div>
        <small
          v-else
          class="text-secondary"
          >Aucun fiche trouvée</small
        >
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:item.state="{ item }">
        <v-chip
          :color="getState(item.state).color"
          dark
        >
          {{ getState(item.state).text }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu
          bottom
          left
          transition="slide-x-reverse-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-if="item.state !== 'VALIDATED'"
              @click="validateConnexion(item)"
            >
              <v-list-item-title> Valider </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.state !== 'REFUSED'"
              @click="refuseConnexion(item)"
            >
              <v-list-item-title>
                <span v-if="item.state === 'VALIDATED'">Annuler</span>
                <span v-else>Refuser</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.state !== 'VALIDATED'"
              @click="updateConnexion(item)"
            >
              <v-list-item-title v-if="item.external_id"> Modifier la fiche </v-list-item-title>
              <v-list-item-title v-else> Ajouter une fiche </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog
      v-model="showRefuseDialog"
      max-width="500px"
      width="auto"
      v-if="activeProConnexion"
    >
      <v-card>
        <v-card-title class="d-flex justify-content-between">
          <div class="d-flex flex-column">
            <span class="headline">Refuser la demande de connexion</span>
            <small>{{ activeProConnexion.name }}</small>
          </div>
          <v-icon @click="showRefuseDialog = false">close</v-icon>
        </v-card-title>

        <v-card-text>
          <v-form
            v-model="refusedForm"
            @submit.prevent="sendRefusalConnexion"
          >
            <v-text-field
              v-model="refusedMessage"
              :rules="[required]"
              outlined
              label="Justifier le refus"
            ></v-text-field>
            <v-btn
              :disabled="!refusedForm"
              block
              color="primary"
              type="submit"
              variant="elevated"
            >
              Envoyer
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showUpdateDialog"
      max-width="500px"
      width="auto"
      v-if="activeProConnexion"
    >
      <v-card>
        <v-card-title class="d-flex justify-content-between">
          <div class="d-flex flex-column">
            <span class="headline">Modifier la demande de connexion</span>
            <small>{{ activeProConnexion.name }}</small>
          </div>
          <v-icon @click="showUpdateDialog = false">close</v-icon>
        </v-card-title>

        <v-card-text>
          <div
            class="d-flex flex-column"
            v-if="!activeProConnexion.external_id"
          >
            <span class="body-1 blue-grey--text text--darken-3"
              >Vous n'avez pas cette fiche dans votre base apidae ?</span
            >
            <span class="body-2"
              >Créez la fiche manuellement sur apidae, puis ajoutez son identifiant dans le champ ci-dessous</span
            >
          </div>
          <v-form
            v-model="updateForm"
            @submit.prevent="updateNumberConnexion"
          >
            <!-- external_id -->
            <v-text-field
              v-model="updateExternalId"
              :rules="[required]"
              outlined
              label="Modifier l'id apidae"
            ></v-text-field>
            <v-btn
              :disabled="!updateForm"
              block
              color="primary"
              type="submit"
              variant="elevated"
            >
              Modifier
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showConfirmValidateDialog"
      max-width="500px"
      width="auto"
      v-if="activeProConnexion"
    >
      <v-card>
        <v-card-title class="d-flex justify-content-between">
          <div class="d-flex flex-column">
            <span class="headline">Valider la demande de connexion</span>
          </div>
          <v-icon @click="showConfirmValidateDialog = false">close</v-icon>
        </v-card-title>

        <v-card-text>
          Souhaitez-vous valider la connexion avec {{ activeProConnexion.name }} ?
          <v-form
            v-model="updateForm"
            @submit.prevent="sendValidationConnexion"
          >
            <v-btn
              block
              color="primary"
              type="submit"
              variant="elevated"
            >
              Valider
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConnexionsList",

  props: {
    list: {
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      search: "",

      showRefuseDialog: false,
      showUpdateDialog: false,
      showConfirmValidateDialog: false,
      activeProConnexion: null,

      refusedForm: false,
      refusedMessage: "",

      updateForm: false,
      updateExternalId: "",

      selectedCity: [],

      headers: [
        {
          text: "Nom",
          align: "start",
          sortable: false,
          value: "name",
        },
          { text: "Catégorie", value: "category" },
        { text: "Commune", value: "city" },
        { text: "Fiche", value: "external_id" },
        { text: "Reçue le", value: "created_at" },
        { text: "Status", value: "state" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    }
  },

  computed: {
    connexionsList() {
      if (this.selectedCity.length > 0) {
        return this.list.filter((connexion) => this.selectedCity.includes(connexion.city))
      } else {
        return this.list
      }
    },

    cities() {
      const array = this.list.map((connexion) => {
        return connexion.city
      })
      array.concat(this.selectedCity)
      return array
    },
  },

  methods: {
    getState(state) {
      switch (state) {
        case "PENDING_CONNECTION":
          return {
            color: "orange",
            text: "en attente",
          }
        case "CONNECTED":
          return {
            color: "green",
            text: "validée",
          }
        default:
          return {
            color: "red",
            text: "refusée",
          }
      }
    },

    encodeUri(id) {
      return btoa(id)
    },

    validateConnexion(item) {
      this.activeProConnexion = item
      this.showConfirmValidateDialog = true
    },

    sendValidationConnexion() {
      this.$http
        .post("auth/pro-connexions/update-state", {
          pro_connexion_id: this.activeProConnexion.id,
          state: "CONNECTED",
        })
        .then((res) => {
          this.showConfirmValidateDialog = false
          this.$emit("reload")
        })
    },

    refuseConnexion(item) {
      this.activeProConnexion = item
      this.showRefuseDialog = true
    },

    sendRefusalConnexion() {
      this.$http
        .post("auth/pro-connexions/update-state", {
          pro_connexion_id: this.activeProConnexion.id,
          state: "REFUSED",
          message: this.refusedMessage,
        })
        .then((res) => {
          this.showRefuseDialog = false
          this.$emit("reload")
        })
    },

    updateConnexion(item) {
      this.activeProConnexion = item
      this.updateExternalId = item.external_id
      this.showUpdateDialog = true
    },

    updateNumberConnexion() {
      this.$http
        .post("auth/pro-connexions/update-external-id", {
          pro_connexion_id: this.activeProConnexion.id,
          external_id: this.updateExternalId,
        })
        .then((res) => {
          this.showUpdateDialog = false
          this.$emit("reload")
        })
    },

    required(v) {
      return !!v || ""
    },
  },
}
</script>
